export default __webpack_public_path__ + "static/Reel_Gaming_German-d1bd9d0cc230a4ea36716dc6d0deb1f0.mp3";